import useAPI from '@/hooks/useAPI';
import KustomerTagRepository from '@/repositories/KustomerTagRepository';

const useKustomerTags = () => {
  const kustomerTagRepository = KustomerTagRepository();

  return useAPI({
    queryKey: ['getKustomerTags'],
    queryFn: async () => await kustomerTagRepository.list()
  });
};

export default useKustomerTags;
